import { Icon } from "../components/ui";

export function Logo({ onClick }: { onClick?: () => void }) {
  return (
    <button
      onClick={onClick}
      style={{ display: "flex", alignItems: "center", gap: 12, background: "none", border: "none", cursor: "pointer", padding: 0, paddingLeft: 4 }}
    >
      <img src="/logo.svg" alt="Logo" style={{ height: 30, width: "auto", display: "block", filter: "var(--logo-filter, none)" }} />
      <span
        style={{
          width: 30,
          height: 30,
          borderRadius: 9,
          background: "var(--accent-soft)",
          color: "var(--accent-text)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "none",
        }}
      >
        <Icon name="compass" size={17} weight="fill" />
      </span>
      <span className="logo-word" style={{ fontSize: 17, fontWeight: 700, letterSpacing: "-0.02em", color: "var(--text)" }}>SpielplatzGIS</span>
    </button>
  );
}
